import React, { useEffect, useState } from "react";
import clsx from "clsx";
import {
  Box,
  Card,
  Grid,
  makeStyles,
  FormControl,
  TextField,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
} from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import { NavLink as RouterLink } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { kmMessages } from "src/constant/Messages";
import { fillMissingTags } from "src/utils/utils";

const nameMaxLength = 300;

const formValidation = {
  required: kmMessages.error.form_validation.field_required,
  maxLength: `${kmMessages.error.form_validation.field_maxlengthnum}${nameMaxLength}`,
};

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(2),
    },
  },
  formcontrol: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  paddingbottom: {
    paddingBottom: theme.spacing(1),
  },
  paddingtop: {
    paddingTop: theme.spacing(2),
  },
  button: {
    margin: theme.spacing(1),
  },
}));

const Form = ({ onSubmit, funct, editMode, ...rest }) => {
  const classes = useStyles();
  const [roleValue, setRoleValue] = useState(null);

  const { handleSubmit, setValue, control, errors } = useForm();

  useEffect(() => {
    if (editMode) {
      setValue("name", funct.name);
      setRoleValue(funct.role);
    }
    return () => {};
  }, [funct]);

  useEffect(() => {
    setTimeout(fillMissingTags(), 1000);
    return () => {};
  }, []);
  
  function handleClick(event) {
    if (event.target.value === roleValue) {
      setRoleValue(null);
    } else {
      setRoleValue(event.target.value);
    }
  }

  const onSubmitLocal = (values) => {
    onSubmit(values, roleValue);
  };

  return (
    <Card className={clsx(classes.root)} {...rest}>
      <Box component="main">
        <Grid container className={classes.root}>
          <Grid item xs={12} elevation={2}>
            <form onSubmit={handleSubmit(onSubmitLocal)}>
              <FormControl
                fullWidth
                className={classes.formcontrol}
                variant="outlined"
              >
                <Controller
                  as={
                    <TextField
                      autoFocus
                      error={errors.name ? true : false}
                      id="name"
                      name="name"
                      label="Nazwa"
                      placeholder="Nazwa"
                      multiline
                      helperText={
                        errors.name && (formValidation[errors.name.type] || "")
                      }
                    />
                  }
                  name="name"
                  defaultValue=""
                  control={control}
                  rules={{ required: true, maxLength: nameMaxLength }}
                />
              </FormControl>
              <FormControl component="fieldset" className={classes.formcontrol}>
                <FormLabel component="legend">Rola:</FormLabel>
                <RadioGroup row aria-label="rola" name="role" value={roleValue}>
                  <FormControlLabel
                    value="member"
                    control={<Radio color="primary" onClick={handleClick} />}
                    label="członek"
                  />
                  <FormControlLabel
                    value="alternate_member"
                    control={<Radio color="primary" onClick={handleClick} />}
                    label="zastępca członka"
                  />
                  <FormControlLabel
                    value="adviser_ke"
                    control={<Radio color="primary" onClick={handleClick} />}
                    label="Głos doradczy-KE"
                  />
                  <FormControlLabel
                    value="umwp"
                    control={<Radio color="primary" onClick={handleClick} />}
                    label="UMWP"
                  />
                  <FormControlLabel
                    value="work_group"
                    control={<Radio color="primary" onClick={handleClick} />}
                    label="Grupa robocza"
                  />
                </RadioGroup>
              </FormControl>
              <Box className={classes.paddingtop}>
                <Button
                  color="primary"
                  className={classes.button}
                  component={RouterLink}
                  to="/administracja/slowniki/2"
                >
                  Anuluj
                </Button>
                <Button
                  color="primary"
                  variant="contained"
                  className={classes.button}
                  endIcon={<SaveIcon />}
                  type="submit"
                >
                  Zapisz
                </Button>
              </Box>
            </form>
          </Grid>
        </Grid>
      </Box>
    </Card>
  );
};

export default Form;
